"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Ba = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 16 8", ...props },
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "ba_svg__a" },
            react_1.default.createElement("path", { d: "M0 0h16v8H0z" }))),
    react_1.default.createElement("g", { clipPath: "url(#ba_svg__a)" },
        react_1.default.createElement("path", { fill: "#002395", d: "M0 0h16v8H0z" }),
        react_1.default.createElement("path", { fill: "#fecb00", d: "M4.24 0h8v8z" }),
        react_1.default.createElement("g", { id: "ba_svg__c" },
            react_1.default.createElement("path", { id: "ba_svg__b", fill: "#fff", d: "M2.353.525 2.8-.85 3.247.525l-1.17-.85h1.446z" }),
            react_1.default.createElement("use", { xlinkHref: "#ba_svg__b", x: 1, y: 1 }),
            react_1.default.createElement("use", { xlinkHref: "#ba_svg__b", x: 2, y: 2 })),
        react_1.default.createElement("use", { xlinkHref: "#ba_svg__c", x: 3, y: 3 }),
        react_1.default.createElement("use", { xlinkHref: "#ba_svg__c", x: 6, y: 6 }))));
exports.default = Ba;
//# sourceMappingURL=Ba.js.map